// Compiler result to JSON file
import { createComponent } from 'js/declViewModelService';
import { registerDynImportEntry } from 'js/moduleLoader';
import AwParseService from 'js/awParseService';
import AwFilterService from 'js/awFilterService';
import { getField } from 'js/utils';
import { Fragment } from 'react';
let filterSer = AwFilterService.instance;
import AwFileUpload from 'viewmodel/AwFileUploadViewModel';
import AwBreak from 'viewmodel/AwBreakViewModel';
import AwButton from 'viewmodel/AwButtonViewModel';
import { EnableWhen } from 'js/hocCollection';
const AwButtonEnableWhen = EnableWhen(AwButton);
AwButtonEnableWhen.displayName = 'AwButtonEnableWhen';

/*
ctx imports
*/

const ctxImportObj = {};

/*
dynamic import
 */
registerDynImportEntry('js/contentFileUploadService', () => import('js/contentFileUploadService'));
registerDynImportEntry('js/accHttpService', () => import('js/accHttpService'));
registerDynImportEntry('js/accEventBus', () => import('js/accEventBus'));
;

/*
view model
 */
const declViewModelJson = {
  "schemaVersion": "1.0.0",
  "props": {
    "accsessionid": {
      "type": "string"
    },
    "collaborationspaceid": {
      "type": "string"
    },
    "rfqid": {
      "type": "string"
    },
    "rfqquoteid": {
      "type": "string"
    }
  },
  "actions": {
    "batchAction": {
      "actionType": "batchJob",
      "steps": [{
        "action": "addContents"
      }, {
        "action": "uploadFileToServer"
      }, {
        "action": "performImport"
      }]
    },
    "updateSelectedFileInfoAction": {
      "actionType": "JSFunction",
      "method": "getSelectedFileInfo",
      "inputData": {
        "fileName": "{{parameters.fileName}}",
        "formData": "{{parameters.formData}}",
        "parameters": "{{parameters}}",
        "maxFilesAllowed": 10
      },
      "outputData": {
        "fileInputForms": "fileInputForms",
        "fileNames": "fileNames",
        "maxFileExceeded": "maxFileExceeded"
      },
      "events": {
        "success": [{
          "condition": "maxFileExceeded",
          "name": "maxFileExceededError"
        }]
      },
      "deps": "js/contentFileUploadService"
    },
    "addContents": {
      "actionType": "JSFunctionAsync",
      "method": "createHttpRequest",
      "inputData": {
        "request": {
          "method": "POST",
          "url": "/acc/orchestrate",
          "withCredentials": true,
          "data": {
            "appBaseUrl": "assets",
            "additionalProperties": {},
            "query": "mutation AddContents( $collaborationspaceId: String, $rfqId: String, $addContentsInput: Json) { addContents( collaborationspaceId: $collaborationspaceId, rfqId: $rfqId, addContentsInput: $addContentsInput) }",
            "variables": {
              "collaborationspaceId": "{{ctx.rfq.collaborationspaceid || props.collaborationspaceid}}",
              "rfqId": "{{ctx.rfq.rfqid || props.rfqid || ctx.rfq.rfqquoteid || props.rfqquoteid}}",
              "addContentsInput": {
                "fileNames": "{{data.fileNames}}"
              }
            }
          }
        },
        "progressIndicatorPrefix": "collab",
        "accSessionId": "{{ctx.rfq.accsessionid || props.accsessionid}}"
      },
      "outputData": {
        "errorCode": "errorCode",
        "addContent": "data.data.addContents",
        "failedFiles": "data.data.failedFiles",
        "partialFileUploadError": "data.data.addContents.partialFileUploadError",
        "ticketIds": "data.data.addContents.ticketIds",
        "stagingAreaId": "data.data.addContents.stagingAreaId",
        "accUrl": "data.data.addContents.url"
      },
      "events": {
        "success": [{
          "condition": "stagingAreaId !== null && stagingAreaId !== undefined",
          "name": "uploadTicketReceived"
        }, {
          "condition": "stagingAreaId !== null && stagingAreaId !== undefined",
          "name": "add-contents-rfq-fileUploadSuccess"
        }, {
          "condition": "stagingAreaId === null || stagingAreaId === undefined",
          "name": "add-contents-rfq-fileUploadError"
        }, {
          "condition": "failedFiles !== null && failedFiles !== undefined && failedFiles !== ''",
          "name": "partialFileUploadError"
        }, {
          "condition": "failedFiles !== null && failedFiles !== undefined && failedFiles !== ''",
          "name": "add-contents-rfq-fileUploadError",
          "eventData": {
            "error": "{{partialFileUploadError}}",
            "errorCode": 400
          }
        }, {
          "condition": "addContents.error === 'EMPTY_COLLAB_SPACE'",
          "name": "add-contents.error",
          "eventData": {
            "error": "{{i18n.EMPTY_COLLAB_SPACE}}",
            "errorCode": 400
          }
        }, {
          "condition": "addContents.error.statusCode === 400 || errorCode === 400",
          "name": "add-contents.error",
          "eventData": {
            "error": "{{addContents.error}}",
            "errorCode": 400
          }
        }, {
          "condition": "addContents.error.statusCode === 403 || errorCode === 403",
          "name": "add-contents.error",
          "eventData": {
            "error": "{{i18n.FORBIDDEN}}",
            "errorCode": 403
          }
        }, {
          "condition": "addContents.error.statusCode === 401 || errorCode === 401 || errorCode === 'INVALID_ACC_SESSION_ID'",
          "name": "add-contents.error",
          "eventData": {
            "error": "{{i18n.UNAUTHORIZED}}",
            "errorCode": 401
          }
        }, {
          "condition": "addContents.error.statusCode >= 500 && addContents.error.statusCode <= 599",
          "name": "add-contents.error",
          "eventData": {
            "error": "{{i18n.ACC_SERVER_ERROR}}",
            "errorCode": 500
          }
        }],
        "failure": [{
          "name": "add-contents.error",
          "eventData": {
            "error": "{{i18n.ACC_SERVER_ERROR}}",
            "errorCode": 500
          }
        }]
      },
      "deps": "js/accHttpService"
    },
    "performImport": {
      "actionType": "JSFunctionAsync",
      "method": "createHttpRequest",
      "inputData": {
        "request": {
          "method": "POST",
          "url": "/acc/orchestrate",
          "withCredentials": true,
          "data": {
            "appBaseUrl": "assets",
            "additionalProperties": {},
            "query": "mutation AddContents( $collaborationspaceId: String, $rfqId: String, $addContentsInput: Json) { addContents( collaborationspaceId: $collaborationspaceId, rfqId: $rfqId, addContentsInput: $addContentsInput) }",
            "variables": {
              "collaborationspaceId": "{{ctx.rfq.collaborationspaceid || props.collaborationspaceid}}",
              "rfqId": "{{ctx.rfq.rfqid || props.rfqid || ctx.rfq.rfqquoteid || props.rfqquoteid}}",
              "addContentsInput": {
                "stagingAreaId": "{{data.stagingAreaId}}"
              }
            }
          }
        },
        "progressIndicatorPrefix": "collab",
        "accSessionId": "{{ctx.rfq.accsessionid || props.accsessionid}}"
      },
      "events": {
        "success": [{
          "name": "add-contents-rfq.contentAdded"
        }],
        "failure": [{
          "name": "add-contents-rfq.addContentFail"
        }]
      },
      "deps": "js/accHttpService"
    },
    "uploadFileToServer": {
      "actionType": "JSFunctionAsync",
      "method": "sendDssFileToUpload",
      "inputData": {
        "accsessionid": "{{ctx.rfq.accsessionid || props.accsessionid}}",
        "accUrl": "{{data.accUrl}}",
        "ticketIds": "{{data.ticketIds}}",
        "formData": "{{data.fileInputForms}}",
        "stagingAreaId": "{{data.stagingAreaId}}",
        "csId": "{{ctx.rfq.collaborationspaceid || props.collaborationspaceid}}",
        "rfqId": "{{ctx.rfq.rfqid || props.rfqid}}"
      },
      "events": {
        "success": [{
          "name": "add-contents-rfq.allFilesUploaded"
        }]
      },
      "deps": "js/contentFileUploadService"
    },
    "publishToACCEventBus": {
      "actionType": "JSFunction",
      "method": "publish",
      "inputData": {
        "eventId": "{{parameters.eventId}}",
        "eventData": "{{parameters.eventData}}"
      },
      "deps": "js/accEventBus"
    }
  },
  "onEvent": [{
    "eventId": "maxFileExceededError",
    "message": "maxFileExceededError"
  }, {
    "eventId": "add-contents-rfq.contentAdded",
    "message": "fileUploadSuccess"
  }, {
    "eventId": "add-contents-rfq.addContentFail",
    "message": "fileUploadError"
  }, {
    "eventId": "add-contents-rfq.contentAdded",
    "action": "publishToACCEventBus",
    "inputArgs": {
      "eventId": "des-add-contents.contentAdded"
    }
  }, {
    "eventId": "add-contents-rfq.addContentFail",
    "action": "publishToACCEventBus",
    "inputArgs": {
      "eventId": "des-add-contents.contentAddFailure"
    }
  }, {
    "eventId": "add-contents-rfq-fileUploadError",
    "action": "publishToACCEventBus",
    "inputArgs": {
      "eventId": "des-add-contents.uploadFailed"
    }
  }, {
    "eventId": "partialFileUploadError",
    "action": "publishToACCEventBus",
    "inputArgs": {
      "eventId": "des-add-contents.uploadFailed",
      "eventData": {
        "message": "{{eventData.error}}",
        "statusCode": "{{eventData.errorCode}}"
      }
    }
  }, {
    "eventId": "add-contents.error",
    "action": "publishToACCEventBus",
    "inputArgs": {
      "eventId": "des-add-contents.error",
      "eventData": {
        "message": "{{eventData.error}}",
        "statusCode": "{{eventData.errorCode}}"
      }
    }
  }],
  "data": {
    "multiple": {
      "displayName": "multiple",
      "type": "BOOLEAN",
      "dbValue": true
    }
  },
  "conditions": {
    "validFile": {
      "expression": "data.fileNames != null && !data.maxFileExceeded"
    }
  },
  "messages": {
    "fileUploadSuccess": {
      "messageType": "INFO",
      "messageText": "File uploaded successfully."
    },
    "fileUploadError": {
      "messageType": "WARNING",
      "messageText": "Error while uploading files."
    },
    "partialFileUploadError": {
      "messageType": "WARNING",
      "messageText": "{{data.failedFiles}}"
    },
    "maxFileExceededError": {
      "messageType": "WARNING",
      "messageText": "Cannot add more than 10 contents."
    }
  },
  "i18n": {
    "Add": ["RfqMessages"],
    "clearFileSelection": ["RfqMessages"],
    "CancelText": ["RfqMessages"],
    "ACC_SERVER_ERROR": ["errorMessages"],
    "EMPTY_COLLAB_SPACE": ["errorMessages"],
    "FORBIDDEN": ["errorMessages"],
    "UNAUTHORIZED": ["errorMessages"]
  },
  "_viewModelId": "AddContentsRfq",
  "_uniqueViewModelId": "AddContentsRfq",
  "ctx": {
    "rfq": {
      "type": "object"
    }
  }
};

/*
<div class="afx-content-background aw-layout-full sw-column">
<form id="upload" action="/upload" method="post" enctype="multipart/form-data">
    <table height="">
        <tr class="tableBody">
            <td>
                <aw-file-upload file-change-action="updateSelectedFileInfoAction" multiple="{{true}}" remove-tooltip="{{i18n.removeFileBtnTooltip}}"></aw-file-upload>
            <aw-break></aw-break>
            </td>
        </tr>
        <tr class="tableFooter">
            <td>
                <aw-button action="batchAction"  enable-when="conditions.validFile" size="auto">{{i18n.Add}}</aw-button>
            </td>
        </tr>
    </table>
</form>
</div>

*/
const renderFn = props => {
  let subPanelContext = props.subPanelContext;
  let {
    viewModel: {
      data,
      dataProviders,
      dispatch,
      conditions,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    },
    grids,
    ctx,
    actions,
    fields,
    messages,
    i18n,
    formProp,
    viewPath
  } = props;
  data = {
    ...data,
    dataProviders
  };
  if (subPanelContext && subPanelContext.fields) {
    fields = {
      ...fields,
      ...subPanelContext.fields
    };
  }
  let $index = null;
  return /*#__PURE__*/React.createElement("div", {
    className: "afx-content-background aw-layout-full sw-column"
  }, /*#__PURE__*/React.createElement("form", {
    id: "upload",
    action: "/upload",
    method: "post",
    encType: "multipart/form-data"
  }, /*#__PURE__*/React.createElement("table", null, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", {
    className: "tableBody"
  }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(AwFileUpload, {
    dndHandler: props.viewModel.dndHandler,
    fileChangeAction: actions.updateSelectedFileInfoAction,
    multiple: AwParseService.instance("true")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    }),
    removeTooltip: AwParseService.instance("i18n.removeFileBtnTooltip")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    })
  }), /*#__PURE__*/React.createElement(AwBreak, null))), /*#__PURE__*/React.createElement("tr", {
    className: "tableFooter"
  }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(AwButtonEnableWhen, {
    action: actions.batchAction,
    size: "auto",
    enableWhen: AwParseService.instance("conditions.validFile")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    })
  }, AwParseService.instance("i18n.Add")({
    props,
    data,
    fields,
    dataProviders,
    ctx,
    i18n,
    actions,
    subPanelContext,
    viewPath,
    conditions,
    formProp,
    dispatch,
    selectionModels,
    editHandlers,
    chartProviders,
    ports
  }))))))));
};

/*
define component
*/
const Component = createComponent(declViewModelJson, renderFn, undefined, ctxImportObj);
export default Component;